export const Hero = () => {
  return (
    <header
      data-testid="hero-section"
      className="py-20 md:py-28 px-6 lg:px-12 border-b border-grove-bsub bg-[radial-gradient(120%_100%_at_50%_0%,#F4F7F4_0%,#FBFBFA_70%)]"
    >
      <div className="max-w-7xl mx-auto">
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-grove-pill text-grove-deep font-mono text-xs mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-grove-mid animate-pulse"></span>
          AI-Powered Equity Research Architecture
        </div>

        <h1
          data-testid="hero-headline"
          className="font-disp text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.98] text-grove-ink max-w-5xl mb-8"
        >
          <span className="eq-line">
            <span>Autonomous equity research for</span>
          </span>
          <span className="eq-line">
            <span>institutional analysts and modern</span>
          </span>
          <span className="eq-line">
            <span className="italic text-grove-deep">rigorous investors.</span>
          </span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end eq-fade-sub">
          <p
            data-testid="hero-subline"
            className="lg:col-span-7 font-body text-lg md:text-xl text-[#3A453F] leading-relaxed max-w-2xl"
          >
            equitygrove streamlines core equity workflows from company primers
            and earnings debriefs to live thesis tracking and deep valuation
            models.
          </p>
          <div className="lg:col-span-5 flex flex-col sm:flex-row gap-4 lg:justify-end">
            <a
              href="#contact"
              data-testid="hero-founder-inquiry-btn"
              className="inline-flex items-center justify-center px-6 py-3.5 bg-grove-deep text-white text-sm font-medium rounded hover:bg-grove-mid transition-all shadow-md"
            >
              Direct Founder Inquiry
            </a>
            <a
              href="#platform"
              data-testid="hero-explore-workflow-btn"
              className="inline-flex items-center justify-center px-6 py-3.5 border border-[#CCD4CE] text-grove-ink text-sm font-medium rounded hover:bg-[#F2F5F3] transition-colors"
            >
              Explore Workflow
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
